import React from 'react';
import './header.css';
import CTA from './CTA'
import HeaderSocials from './HeaderSocials'


const Header = () => {


  return (
    <header>
      <div className="container header__container">
        <div className="header__top">
        </div>
        <div className="header__content">
          <h1 className="fade-in">Bem-vindo ao meu portfolio! <br/> <span className='name'>Abílio Aragão - Desenvolvedor Fullstack</span></h1>

          <CTA/>
          <HeaderSocials/>
          <a href='#contact' className='scroll__down'>Role para baixo</a>
        </div>
      </div>
    </header>
  );
}

export default Header;
